interface ICookie {
  name: string;
  value: string;
  path?: string;
  domain?: string;
  version?: string;
  expires?: string;
  secure?: boolean;
  httpOnly?: boolean;
}

interface ICookies {
  [key: string]: ICookie;
}

export default {
  set: async (url: string, cookie: ICookie, useWebKit?: boolean) => {
    // eslint-disable-next-line no-console
    console.log('@react-native-cookies/cookies', 'set', url, cookie, useWebKit);
    return false;
  },
  get: async (url: string, useWebKit?: boolean): Promise<ICookies> => {
    // eslint-disable-next-line no-console
    console.log('@react-native-cookies/cookies', 'get', url, useWebKit);
    return {};
  }
};
